/**
 * UserLayout - Layout for authenticated user pages
 *
 * IMPORTANT: This is a MINIMAL layout wrapper that only provides the <Outlet />
 * for nested routes. It does NOT add Layout.Basic or NavigationRequireAuth
 * because the individual user page components already include them.
 *
 * Why: Legacy user pages were built with Layout.Basic + NavigationRequireAuth
 * inside each component. Adding them here would duplicate header/footer.
 *
 * This layout exists for:
 * - Grouping /user/* routes semantically
 * - Future shared logic (if needed)
 * - Consistency with RR7 nested routing pattern
 *
 * Usage in routes:
 * {
 *   path: 'user',
 *   Component: UserLayout,
 *   children: [...]
 * }
 */
import {Outlet} from 'react-router-dom'

/**
 * UserLayout component
 * Simple wrapper for user pages - components handle their own layout/auth
 */
export function UserLayout() {
  return <Outlet />
}

export default UserLayout
